import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const ChatMessage = ({ message, isOwnMessage, currentLanguage }) => {
  const translations = {
    en: {
      translated: 'Translated',
      original: 'Original',
      viewAttachment: 'View Attachment'
    },
    ko: {
      translated: '번역됨',
      original: '원본',
      viewAttachment: '첨부파일 보기'
    }
  };

  const t = translations?.[currentLanguage];

  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    return date?.toLocaleTimeString(currentLanguage === 'ko' ? 'ko-KR' : 'en-US', {
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className={`flex gap-3 ${isOwnMessage ? 'flex-row-reverse' : 'flex-row'} mb-4 md:mb-6`}>
      <div className="flex-shrink-0">
        <Image
          src={message?.avatar}
          alt={message?.avatarAlt}
          className="w-10 h-10 md:w-12 md:h-12 rounded-full object-cover"
        />
      </div>
      <div className={`flex flex-col gap-2 max-w-[75%] md:max-w-[65%] lg:max-w-[60%] ${isOwnMessage ? 'items-end' : 'items-start'}`}>
        <div className="flex items-center gap-2">
          <span className="text-sm md:text-base font-medium text-foreground">{message?.sender}</span>
          <span className="text-xs md:text-sm text-muted-foreground caption">{formatTime(message?.timestamp)}</span>
        </div>

        <div className={`rounded-2xl px-4 py-3 md:px-5 md:py-4 ${
          isOwnMessage 
            ? 'bg-primary text-primary-foreground' 
            : 'bg-muted text-foreground'
        }`}>
          <p className="text-sm md:text-base leading-relaxed whitespace-pre-wrap break-words">
            {message?.content}
          </p>

          {message?.translated && (
            <div className="mt-3 pt-3 border-t border-current/20">
              <div className="flex items-center gap-2 mb-2">
                <Icon name="Languages" size={14} />
                <span className="text-xs caption">{t?.translated}</span>
              </div>
              <p className="text-xs md:text-sm opacity-90 leading-relaxed">
                {message?.translatedContent}
              </p>
            </div>
          )}

          {message?.attachment && (
            <div className="mt-3 pt-3 border-t border-current/20">
              <div className="flex items-center gap-3 p-3 rounded-lg bg-background/10">
                <Icon name={message?.attachment?.type === 'image' ? 'Image' : 'FileText'} size={20} />
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium truncate">{message?.attachment?.name}</p>
                  <p className="text-xs opacity-80 caption">{message?.attachment?.size}</p>
                </div>
                <button className="flex-shrink-0 p-2 hover:bg-background/20 rounded-lg transition-base">
                  <Icon name="Download" size={18} />
                </button>
              </div>
            </div>
          )}
        </div>

        {message?.read && isOwnMessage && (
          <div className="flex items-center gap-1 px-2">
            <Icon name="CheckCheck" size={14} color="var(--color-success)" />
            <span className="text-xs text-success caption">Read</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default ChatMessage;